import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardViewer from './components/DashboardViewer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/population-level-analysis" replace />} />
          <Route path="/population-level-analysis" element={<DashboardViewer dashboardId="population-level-analysis" />} />
          <Route path="/patient-level-analysis" element={<DashboardViewer dashboardId="patient-level-analysis" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
